import JwtDecode from 'jwt-decode'
import VueCookies from 'vue-cookies'

export default (server) => {
  server.get('/token', () => {
    return JwtDecode(VueCookies.get(process.env.VUE_APP_COOKIE_NAME))
  })
}
